import {
  Box as Form,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Text,
} from '@chakra-ui/react';
import { Container } from 'components/Layout/Container';
import { useAuth } from 'context/AuthUserContext';
import Link from 'next/link';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useTheme } from 'styled-components';

type Inputs = {
  fullName: string;
  email: string;
  password: string;
};

export const SignUpForm = () => {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm<Inputs>();
  const { createUserWithEmailAndPassword } = useAuth();
  const { colors } = useTheme();

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    const { email, password } = data;

    try {
      const user = await createUserWithEmailAndPassword(email, password);
      console.log({ user });
    } catch (error: any) {
      if (error?.code === 'auth/email-already-in-use') {
        setError('email', { message: 'Email already in use.' });
      }
      console.log({ error });
    }
  };

  return (
    <Container display="flex" justifyContent="center" p="75px 0 150px 0">
      <Form
        maxW="500px"
        w="100%"
        as="form"
        onSubmit={handleSubmit(onSubmit)}
        borderRadius="4px"
        p="35px 50px"
        bg={colors.white}
      >
        <FormControl isInvalid={!!errors.fullName} mb="12px">
          <FormLabel htmlFor="fullName">Full Name</FormLabel>
          <Input
            id="fullName"
            placeholder="John Doe"
            {...register('fullName', {
              required: 'This is required',
            })}
          />
          <FormErrorMessage>
            {errors.fullName && errors.fullName.message}
          </FormErrorMessage>
        </FormControl>
        <FormControl isInvalid={!!errors.email} mb="12px">
          <FormLabel htmlFor="email">Email</FormLabel>
          <Input
            id="email"
            placeholder="name@example.com"
            type="email"
            {...register('email', {
              required: 'Name is required',
            })}
          />
          <FormErrorMessage>
            {errors.email && errors.email.message}
          </FormErrorMessage>
        </FormControl>
        <FormControl isInvalid={!!errors.password}>
          <FormLabel htmlFor="password">Password</FormLabel>
          <Input
            id="password"
            type="password"
            placeholder="Minimum 8 Characters"
            {...register('password', {
              required: 'Password is required',
              minLength: { value: 8, message: 'Minimum length should be 8' },
            })}
          />
          <FormErrorMessage>
            {errors.password && errors.password.message}
          </FormErrorMessage>
        </FormControl>
        <Button
          mt={4}
          isLoading={isSubmitting}
          type="submit"
          variant="primary"
          w="100%"
        >
          Submit
        </Button>
        <Text mt="30px" fontWeight={500} textAlign="center">
          Already have an account?{' '}
          <Link href="/sign-in" passHref>
            <Text as="a" color="#3ba1df" textDecoration="underline">
              Log In
            </Text>
          </Link>
        </Text>
      </Form>
    </Container>
  );
};
